import React, { useEffect, useState } from "react";
import { Phone, Menu, X, ChevronDown } from "lucide-react";
import { BRAND } from "../mock";
import { Button } from "./ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "./ui/dropdown-menu";

const NAV = [
  { label: "About Us" },
  {
    label: "Domestic",
    children: ["Kerala", "Himachal", "Rajasthan", "Kashmir", "Goa", "Uttarakhand"],
  },
  {
    label: "International",
    children: ["Nepal", "Bhutan", "Maldives", "Dubai"],
  },
  { label: "Upcoming Trips" },
  {
    label: "More",
    children: ["Blog", "Careers", "Contact"],
  },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-300 ${
        scrolled ? "bg-white/95 backdrop-blur shadow-sm" : "bg-white/90 backdrop-blur"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8 h-[84px] flex items-center justify-between">
        {/* Logo */}
        <a href="#top" className="flex items-center gap-2">
          <div className="px-4 py-2 rounded-xl" style={{ backgroundColor: "#1F5B63" }}>
            <img
              src={BRAND.logo}
              alt="Trevora"
              className="h-8 md:h-9 w-auto object-contain"
            />
          </div>
        </a>

        {/* Nav */}
        <nav className="hidden lg:flex items-center gap-1">
          {NAV.map((item) =>
            item.children ? (
              <DropdownMenu key={item.label}>
                <DropdownMenuTrigger className="px-3 py-2 text-sm font-medium text-slate-700 hover:text-[#1F5B63] rounded-md flex items-center gap-1 outline-none">
                  {item.label}
                  <ChevronDown className="h-4 w-4" />
                </DropdownMenuTrigger>
                <DropdownMenuContent align="start" className="min-w-[180px]">
                  {item.children.map((c) => (
                    <DropdownMenuItem key={c} className="cursor-pointer">
                      {c}
                    </DropdownMenuItem>
                  ))}
                </DropdownMenuContent>
              </DropdownMenu>
            ) : (
              <a
                key={item.label}
                href={`#${item.label.toLowerCase().replace(/\s/g, "-")}`}
                className="px-3 py-2 text-sm font-medium text-slate-700 hover:text-[#1F5B63] rounded-md"
              >
                {item.label}
              </a>
            )
          )}
        </nav>

        {/* Phone CTA */}
        <div className="flex items-center gap-3">
          <a
            href={`tel:${BRAND.phoneRaw}`}
            className="hidden sm:inline-flex items-center gap-2 px-4 py-2 rounded-full border border-[#1F5B63]/25 text-[#1F5B63] hover:bg-[#1F5B63] hover:text-white transition-colors text-sm font-semibold"
          >
            <Phone className="h-4 w-4" />
            {BRAND.phone}
          </a>
          <button
            className="lg:hidden p-2 rounded-md text-slate-700"
            onClick={() => setOpen(!open)}
            aria-label="Menu"
          >
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="lg:hidden bg-white border-t border-slate-100">
          <div className="px-5 py-4 flex flex-col gap-1">
            {NAV.map((item) => (
              <a
                key={item.label}
                href="#top"
                onClick={() => setOpen(false)}
                className="px-2 py-3 text-slate-700 font-medium border-b border-slate-100"
              >
                {item.label}
              </a>
            ))}
            <a
              href={`tel:${BRAND.phoneRaw}`}
              className="mt-3 inline-flex items-center justify-center gap-2 px-4 py-3 rounded-full bg-[#1F5B63] text-white font-semibold"
            >
              <Phone className="h-4 w-4" /> {BRAND.phone}
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
